if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('.product-form__submit:not([data-jhny-buy-now])') || this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const activeSubmitButton = evt.submitter || this.submitButton;
      if (this.submitting || !activeSubmitButton || activeSubmitButton.disabled || activeSubmitButton.getAttribute('aria-disabled') === 'true') return;
      this.submitting = true;
      this.error = false;
      const buyNow = activeSubmitButton.hasAttribute('data-jhny-buy-now');
      const activeSpinner = activeSubmitButton.querySelector('.loading-overlay__spinner');

      this.handleErrorMessage();

      activeSubmitButton.setAttribute('aria-disabled', true);
      activeSubmitButton.classList.add('loading');
      if (activeSpinner) activeSpinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = this.form ? new FormData(this.form) : new FormData();
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const addonInput = this.form ? this.form.querySelector('[data-jhny-frame-addon]') : null;
      const addonVariantId = addonInput ? String(addonInput.value || '') : '';
      const quantity = Number(formData.get('quantity') || 1);
      const overrideInput = this.form ? this.form.querySelector('[data-jhny-product-override]') : null;
      const overrideVariantId = overrideInput ? String(overrideInput.value || '') : '';
      const productVariantId = overrideVariantId || String(formData.get('id') || '');
      if (overrideVariantId) formData.set('id', overrideVariantId);

      if (addonVariantId && productVariantId) {
        const bundleKey = `jhny-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const frameColor = addonInput.getAttribute('data-frame-color') || '';
        const productTitleElement = this.closest('.product__outer')?.querySelector('.product__title, h1, h2');
        const productTitle = productTitleElement?.textContent?.trim() || 'Canvas artwork';
        const payload = {
          items: [
            {
              id: productVariantId,
              quantity,
              properties: { '_jhny_bundle': bundleKey },
            },
            {
              id: addonVariantId,
              quantity,
              properties: {
                '_jhny_bundle': bundleKey,
                'For': productTitle,
                'Frame color': frameColor,
              },
            },
          ],
        };
        if (this.cart) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);
      } else {
        if (this.cart) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
      }

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      config.signal = controller.signal;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent('cart:error', {
                detail: {
                  source: 'product-form',
                  productVariantId,
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          if (buyNow) {
            window.location = `${window.Shopify?.routes?.root || '/'}checkout`;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          document.dispatchEvent(
            new CustomEvent('variant:add', {
              detail: {
                variant: { id: productVariantId },
                quantity,
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );

          fetch(`${routes.cart_url}.js`)
            .then((cartResponse) => cartResponse.text())
            .then((state) => {
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: JSON.parse(state),
                    sectionId: this.dataset.source,
                  },
                })
              );
            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            });

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId});
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error(error);
          this.handleErrorMessage(window.variantStrings.cartError);
        })
        .finally(() => {
          clearTimeout(timeout);
          activeSubmitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitting = false;
          if (!activeSubmitButton.hasAttribute('data-jhny-preview-locked')) activeSubmitButton.removeAttribute('aria-disabled');
          if (activeSpinner) activeSpinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

